import React from 'react';
import Icon from '../../../components/AppIcon';


const ReportHeader = ({ companyData, reportDate, reportId }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-8 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
        <div className="flex items-start gap-4">
          <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="FileText" size={32} color="var(--color-primary)" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
              Laporan Due Diligence Eksekutif
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Analisis Komprehensif untuk Pengambilan Keputusan Strategis
            </p>
          </div>
        </div>
        
        <div className="flex flex-col gap-2 text-sm">
          <div className="flex items-center gap-2">
            <Icon name="Building2" size={16} color="var(--color-muted-foreground)" />
            <span className="text-muted-foreground">Perusahaan:</span>
            <span className="font-medium text-foreground">{companyData?.name}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
            <span className="text-muted-foreground">Tanggal Laporan:</span>
            <span className="font-medium text-foreground">{reportDate}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Hash" size={16} color="var(--color-muted-foreground)" />
            <span className="text-muted-foreground">ID Laporan:</span>
            <span className="font-medium text-foreground data-text">{reportId}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;